"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SessionHelper = void 0;
var core_1 = require("../../../core");
var local_storage_1 = require("../../../core/local-storage");
var session_1 = require("./session");
var getTotalGuests = function (session) {
    var guests = session === null || session === void 0 ? void 0 : session.context.guests;
    return Object.keys(guests).reduce(function (acc, guestKey) { return acc + guests[guestKey]; }, 0);
};
var getSessionOccupancy = function (session) {
    return session === null || session === void 0 ? void 0 : session.context.guests;
};
var formatArrivalDate = function (session) {
    var stayPeriod = session.context.stayPeriod;
    var language = session.display.culture;
    var arrivalDate = core_1.DateUtil.removeTimeFromDate(new Date(stayPeriod.arrivalDate));
    return core_1.DateUtil.formatCalendarDate(arrivalDate, language);
};
var formatDepartureDate = function (session) {
    var stayPeriod = session.context.stayPeriod;
    var language = session.display.culture;
    var departureDate = core_1.DateUtil.removeTimeFromDate(new Date(stayPeriod.departureDate));
    return core_1.DateUtil.formatCalendarDate(departureDate, language);
};
var formatStayPeriod = function (session) {
    return formatArrivalDate(session) + " - " + formatDepartureDate(session);
};
var getNumberOfNights = function (session) {
    return core_1.DateUtil.getAllPossibleStayPeriod(session.context.stayPeriod).length;
};
var addPromoCodeFromLocalStorage = function (sessionContext) {
    var promoCode = (sessionContext === null || sessionContext === void 0 ? void 0 : sessionContext.promoCode) || local_storage_1.LocalStorage.get(session_1.PROMOCODE_KEY);
    var updatedSessionContext = __assign({}, sessionContext);
    if (promoCode) {
        updatedSessionContext = __assign(__assign({}, sessionContext), { promoCode: promoCode });
    }
    return updatedSessionContext;
};
exports.SessionHelper = {
    getTotalGuests: getTotalGuests,
    getSessionOccupancy: getSessionOccupancy,
    formatStayPeriod: formatStayPeriod,
    formatArrivalDate: formatArrivalDate,
    formatDepartureDate: formatDepartureDate,
    getNumberOfNights: getNumberOfNights,
    addPromoCodeFromLocalStorage: addPromoCodeFromLocalStorage
};
//# sourceMappingURL=session.helper.js.map